import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const ThemeCtx = createContext({
  theme: "dark",
  setTheme: () => {},
  toggleTheme: () => {},
});

export function useTheme() {
  return useContext(ThemeCtx);
}

export default function ThemeProvider({ children }) {
  const initial = (typeof window !== "undefined" && localStorage.getItem("theme")) || "dark";
  const [theme, setTheme] = useState(initial === "light" ? "light" : "dark");

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    html.setAttribute("data-theme", theme);

    if (theme === "light") body.classList.add("white-mode");
    else body.classList.remove("white-mode");

    try { localStorage.setItem("theme", theme); } catch {}
  }, [theme]);

  const toggleTheme = () => setTheme((t) => (t === "light" ? "dark" : "light"));
  const value = useMemo(() => ({ theme, setTheme, toggleTheme }), [theme]);

  return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>;
}